// Datos ficticios de ejemplo — plantilla "Jardín de Mariposas"
// (cumpleaños infantil femenino). Ilustraciones originales: mariposas y flores.
// Sin personajes comerciales.

export const datosEjemplo = {
  tipoEvento: "infantil",
  plantillaId: "infantil-mariposas",

  secciones: [
    { id: "portada", visible: true, orden: 0 },
    { id: "cuentaRegresiva", visible: true, orden: 1, etiqueta: "¡Falta poquito!", titulo: "Contando las flores", textoFinalizado: "¡Hoy florece la fiesta!" },
    { id: "eventos", visible: true, orden: 2, etiqueta: "Dónde y cuándo", titulo: "El jardín de la fiesta" },
    { id: "calendario", visible: true, orden: 3, etiqueta: "Agendalo", titulo: "Guardá la fecha" },
    { id: "galeria", visible: true, orden: 4, etiqueta: "Fotos", titulo: "Momentos de Isabella" },
    { id: "itinerario", visible: true, orden: 5, etiqueta: "El plan", titulo: "Una tarde de jardín" },
    { id: "menciones", visible: false, orden: 6, etiqueta: "Familia", titulo: "Quienes la cuidan" },
    { id: "video", visible: false, orden: 7, etiqueta: "Video", titulo: "Mirá el video" },
    { id: "musica", visible: true, orden: 8, etiqueta: "A cantar", titulo: "Canciones del jardín" },
    { id: "rsvp", visible: true, orden: 9, etiqueta: "Confirmación", titulo: "¿Venís a volar conmigo?" },
    { id: "enlaces", visible: true, orden: 10, etiqueta: "Datos útiles", titulo: "Para las mamás y papás" },
    { id: "accesos", visible: true, orden: 11, etiqueta: "Participá", titulo: "Dejale una flor" },
    { id: "cierre", visible: true, orden: 12 },
  ],

  protagonista: {
    nombre: "Isabella",
    edad: 4,
    textoEdad: "años",
    fraseIntroductoria: "¡Cumplo años!",
    mensajePortada:
      "Te espero en mi jardín para una tarde de mariposas, juegos y merienda dulce.",
    mensajeCierre:
      "¡Gracias por volar hasta mi fiesta! La pasé hermoso con vos.",
    textoBotonEntrada: "¡Volar a la fiesta!",
  },

  evento: {
    fechaISO: "2027-02-14T16:00:00-03:00",
    fechaLegible: "Domingo 14 de febrero de 2027",
    fechaCorta: "14 · 02 · 2027",
    ciudad: "Capiatá, Paraguay",
  },

  fotos: {
    portada:
      "https://images.unsplash.com/photo-1464349095431-e9a21285b5f3?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400&auto=format&fit=crop",
    galeria: [
      {
        src: "https://images.unsplash.com/photo-1464349095431-e9a21285b5f3?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200&auto=format&fit=crop",
        alt: "Torta de cumpleaños con velitas",
      },
      {
        src: "https://images.unsplash.com/photo-1530103862676-de8c9debad1d?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200&auto=format&fit=crop",
        alt: "Globos de colores",
      },
      {
        src: "https://images.unsplash.com/photo-1513151233558-d860c5398176?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200&auto=format&fit=crop",
        alt: "Confeti de colores",
      },
      {
        src: "https://images.unsplash.com/photo-1464349153735-7db50ed83c84?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200&auto=format&fit=crop",
        alt: "Torta con velas de feliz cumpleaños",
      },
    ],
  },

  eventos: [
    {
      id: "fiesta",
      etiqueta: "La fiesta",
      lugar: "Quinta Los Jazmines",
      direccion: "Camino a la Loma, km 3, Capiatá",
      horario: "16:00 a 19:30 h",
      urlUbicacion:
        "https://www.google.com/maps/search/?api=1&query=Capiat%C3%A1+Paraguay",
      textoBoton: "Cómo llegar",
    },
  ],

  calendario: {
    titulo: "Cumpleaños de Isabella (4 años)",
    descripcion: "Fiesta de 16:00 a 19:30 h en Quinta Los Jazmines, Capiatá.",
    texto: "Domingo 14 de febrero de 2027 · Capiatá. ¡Que no se te pase!",
    textoBotonGoogle: "Google Calendar",
    textoBotonIcs: "Descargar evento (.ics)",
    inicioISO: "2027-02-14T16:00:00-03:00",
    finISO: "2027-02-14T19:30:00-03:00",
    ubicacion: "Quinta Los Jazmines, Capiatá, Paraguay",
  },

  itinerario: [
    { hora: "16:00", titulo: "Bienvenida al jardín", descripcion: "Coronas de flores para todas.", icono: "corazon" },
    { hora: "16:30", titulo: "Juegos de mariposas", descripcion: "Búsqueda del tesoro y pelotero.", icono: "brillo" },
    { hora: "17:30", titulo: "Merienda dulce", descripcion: "Cupcakes, frutas y limonada.", icono: "cena" },
    { hora: "18:15", titulo: "Piñata de flores", descripcion: "A romperla entre todas.", icono: "fiesta" },
    { hora: "18:45", titulo: "La torta", descripcion: "Cantamos el feliz cumpleaños.", icono: "copas" },
    { hora: "19:15", titulo: "Despedida", descripcion: "Bolsita de semillas para plantar.", icono: "musica" },
  ],

  video: {
    urlYoutube: "https://www.youtube.com/watch?v=aqz-KE-bpKQ",
  },

  musica: {
    tipo: "spotify",
    url: "https://open.spotify.com/playlist/37i9dQZF1DXcBWIGoYBM5M",
    nota: "Dale play para escuchar las canciones del jardín. Nunca arranca sola.",
  },

  rsvp: {
    mensaje:
      "Avisanos si venís así preparamos tu corona de flores (y tu porción de torta).",
    textoBoton: "Confirmar asistencia",
    fechaLimite: "Por favor confirmá antes del 31 de enero de 2027",
  },

  enlaces: [
    { texto: "Sugerencias de regalos", url: "https://www.pinterest.com" },
    { texto: "Mapa de la zona", url: "https://www.google.com/maps/search/?api=1&query=Capiat%C3%A1+Paraguay" },
  ],

  accesos: {
    libroFirmas: {
      titulo: "Libro de firmas",
      texto: "Dejale un mensaje para su jardín de recuerdos.",
    },
    album: {
      titulo: "Álbum colaborativo",
      texto: "Subí las fotos que saques en la fiesta.",
    },
  },

  legal: {
    urlPrivacidad: "https://pro360.com.py/privacidad",
    urlCondiciones: "https://pro360.com.py/condiciones",
    textoPrivacidad: "Privacidad",
    textoCondiciones: "Condiciones",
    marca: "Hecho con amor · Pro360 Invitaciones Digitales Plus",
  },
};
